import {
  Avatar,
  Box,
  Divider,
  Grid,
  lighten,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import * as d3 from 'd3';
import React from 'react';
import clsx from 'classnames';
import { DomainTypeGq } from '../../../../../graphql/projects/models/DomainTypeGq';
import { AnalysisFilterState } from '../../../Filter/analysisFilterState';
import { ColorPalette } from '../../../Palette/ColorPalette';

export interface HeaderProps {
  label: string;
  type: DomainTypeGq;
  traffic: number;
  analysisFilterState: AnalysisFilterState;
  palette: ColorPalette;
  textColor: string;
}

export const useClasses = makeStyles((theme: Theme) => ({
  avatar: {
    width: '54px',
    height: '54px',
    fontSize: '16px',
  },
  avatarClient: {
    backgroundColor: theme.palette.info.main,
  },
  avatarCompetitor: {
    backgroundColor: lighten(theme.palette.secondary.light, 0),
  },
  avatarAutomatic: {
    backgroundColor: lighten(theme.palette.secondary.dark, 0.3),
  },
}));

const numberFormatter = d3.format('.2s');

export const Header: React.FC<HeaderProps> = ({
  label,
  type,
  traffic,
  analysisFilterState,
  palette,
  textColor,
}) => {
  const classes = useClasses();
  let backgroundColor = '';
  if (type === DomainTypeGq.PROJECT) backgroundColor = palette.secondaryScale[1];
  if (type === DomainTypeGq.COMPETITOR) backgroundColor = palette.primaryScale[2];
  if (type === DomainTypeGq.AUTOMATIC && !analysisFilterState.competitorColor)
    backgroundColor = palette.primaryScale[2];
  if (type === DomainTypeGq.AUTOMATIC && !!analysisFilterState.competitorColor)
    backgroundColor = palette.primaryScale[1];
  return (
    <>
      <Avatar
        className={clsx({
          [classes.avatar]: true,
        })}
        style={{ backgroundColor, color: textColor }}
      >
        {traffic > 999 ? numberFormatter(traffic) : Math.round(traffic)}
      </Avatar>
      <Grid item>
        <div className="my-2">
          <Typography>{label}</Typography>
        </div>
        <div className="mb-2">
          <Divider />
        </div>
      </Grid>
    </>
  );
};

export default Header;
